import defineComponent from 'flight';
import console from '../../../../utils/console';
import _ from 'underscore';
import $ from 'jquery';
import almostRandom from '../../../../utils/almost-random';
import pjaxPersister from '../../../../utils/pjax-persister';
import AdSlot from './ad-slot';

function GoogleAdsLoader() {

    this.defaultAttrs({
        scrollEventListener: '',
        initData: null,
        gptDivIdPrefix: 'g-ad-'
    });

    this._slots = [];
    this._isGPTLoaded = 'GOOGLE_PUBLISHER_TAG_LOADED';

    this._initializeService = function () {
        if (pjaxPersister.isFalse(this._isGPTLoaded)) {
            this._log('Initializing Google Publisher Tag');

            googletag.cmd.push(function () {
                this._setPublisherProvidedId();

                googletag.pubads().addEventListener('slotRenderEnded', this._adjustAdSize.bind(this));
                googletag.pubads().addEventListener('slotRenderEnded', this._markAdAsLoaded.bind(this));
                googletag.pubads().addEventListener('slotRenderEnded', this._addStyling.bind(this));
                googletag.pubads().addEventListener('slotRenderEnded', this._collapseEmpty.bind(this));
                googletag.pubads().addEventListener('slotRenderEnded', this._metrics.bind(this));
                googletag.pubads().addEventListener('slotRenderEnded', this._showMobileTopContainer.bind(this));
                googletag.pubads().addEventListener('slotRenderEnded', this._showTakeOver.bind(this));

                googletag.pubads().enableSingleRequest();
                googletag.pubads().disableInitialLoad();
                googletag.enableServices();

                pjaxPersister.set(this._isGPTLoaded, true);

                this._log('Google Publisher Tag initialized');
            }.bind(this));
        }
    };

    this._setPublisherProvidedId = function () {
        let isGptDataDefined = this.attr.initData.gptData !== null && this.attr.initData.gptData !== undefined;
        if (isGptDataDefined && this.attr.initData.gptData.publisherProvidedId) {
            let gptData = this.attr.initData.gptData;
            googletag.pubads().setPublisherProvidedId(gptData.publisherProvidedId);
            this._log('Setting PPID', gptData.publisherProvidedId);
        }
    };


    this._showTakeOver = function (evt) {
        let $ad_el = $('#' + this._getIdFromAdEvent(evt));
        let $ad_slot = $ad_el.parent();

        if ($ad_slot.hasClass('g-ad-rm') && !evt.isEmpty) {
            let takeoverElement = document.getElementById('g-ad-takeover');
            // make sure it's possible to close the takeover
            $('.g-ad-takeover-header').click(() => {
                takeoverElement.style.width = '0';
            });

            let $sf = $ad_el.find('iframe:first');
            if ($sf.attr('data-is-safeframe') !== 'true') {
                this._log('Takeover doesnt have a safeframe, dont use Traderas takeover template');
                return;
            }

            // expand the safe frame overlay and make sure the iframe fits there
            takeoverElement.style.width = '100%';
            $sf.css('position', 'absolute');
            $sf.css('top', '0');
            $sf.css('left', '0');
            $sf.css('margin', '0');
            $sf.css('width', '100%');
            $sf.css('height', '100%');
        }
    };

    this._showMobileTopContainer = function (evt) {
        let $ad_el = $('#' + this._getIdFromAdEvent(evt));
        let $ad_slot = $ad_el.parent();
        if ($ad_slot.hasClass('g-ad-slot-top-mobile')) {
            if (!evt.isEmpty) {
                $ad_slot.parent().show();
            }
            // make sure that no id's for google-ad-banner-top-mobile continue to exist in the DOM
            $ad_slot.removeAttr('id');
            $('#google-ad-banner-top-mobile').removeAttr('id');
        }
    };

    this._getIdFromAdEvent = evt => evt.slot.getSlotElementId();

    this._markAdAsLoaded = function (evt) {
        let idSelector = '#' + this._getIdFromAdEvent(evt);

        if (idSelector.startsWith('#g-ad-rm')) {
            return;
        }

        $(idSelector).addClass('g-ad-slot-loaded');
    };

    this._collapseEmpty = function (evt) {
        if (evt.isEmpty) {
            let id = this._getIdFromAdEvent(evt);
            this._collapseDiv(id);
        }
    };

    this._collapseDiv = function (id) {
        let idSelector = '#' + id;
        this._log('Collapsing parent for ' + idSelector);
        $(idSelector).parent().addClass('hidden');
    };

    this._metrics = function (evt) {
        let targeting = evt.slot.getTargetingMap();

        if (targeting.pos) {
            this.trigger(document, 'ui:gpt:slot-loaded',
                {
                    position:
                        targeting.pos
                }
            );
        }
    };

    this._addStyling = function (evt) {
        let width = evt.size[0];
        let height = evt.size[1];
        if (width === 728 && height === 410) {
            let idSelector = '#' + this._getIdFromAdEvent(evt);
            $(idSelector).parent().addClass('video');
        }
    };

    this._adjustAdSize = function (evt) {
        if (evt.size) {
            let id = this._getIdFromAdEvent(evt);
            let width = evt.size[0];
            let height = evt.size[1];

            this._adjustDivSize(id, width, height);
        }
    };

    this._adjustDivSize = function (id, width, height) {
        let idSelector = '#' + id;

        this._log('Adjusting [max-width, min-height] for ' + idSelector, [width, height]);

        let isVideo = width === 728 && height === 410;
        if (!isVideo) {
            $(idSelector).parent().css('max-width', width).css('min-height', height);
        }

        $(idSelector).css('width', width).css('height', height);
    };

    this._loadAds = function () {

        // is it the first time load or pagination load
        if (typeof this._slots === 'undefined') {
            this._slots = [];
        }

        this.trigger(document, 'ui:gpt:start-loading-ads');
        let gptData = this.attr.initData.gptData;
        this._log('Start loading ads ' + gptData.adUnitPath);

        googletag.cmd.push(function () {
            let createdSlots = [];
            _.each(gptData.slots, this._createSlot.bind(this, gptData.adUnitPath, createdSlots));

            this._createOutOfPageSlot(gptData.adUnitPath, gptData.outOfPageSlot, createdSlots);

            _.each(gptData.customTargetingParameters, function (value, key) {
                if (key === 'firstLook') {
                    value = value.replace('_first', '');
                }
                googletag.pubads().setTargeting(key, value);
                this._log('Service custom targeting parameter', [key, value]);
            }.bind(this));

            googletag.pubads().refresh(createdSlots);

        }.bind(this));
    };

    this._removeTopMobileSlotId = function () {
        $('#google-ad-banner-top-mobile').removeAttr('id');
        this._loadAds();
    };

    this._createSlot = function (adUnitPath, createdSlots, slotData) {
        /* Temp code for AB test for side slots on VIP */
        const stickySlots = ['side1-desktop', 'side2-desktop'];
        let isSideSlot = stickySlots.includes(slotData.position);

        if (isSideSlot && !this._shouldSideSlotsBeLoaded()) {
            return;
        }
        /* End temp code */
        
        let slotDiv = 'htmlDomId' in slotData ? $(`#${slotData.htmlDomId}`): $(`#google-ad-banner-${slotData.position}`);
        if (slotDiv.length <= 0) {
            this._log('Slot not created. Slot div doesnt exist: ' + slotData.position);
            return;
        } else if (slotDiv.children().length > 0) {
            //  AdSlot already has content inside, skip: ' + slotData.position
            this._log('AdSlot already has content inside, skip: ' + slotData.position);
            return;
        }

        let elementId = this.attr.gptDivIdPrefix + slotData.position + '-' + almostRandom.get();
        this._log('Creating slot: ' + slotData.position + ', adunit: ' + adUnitPath);
        this.trigger(document, 'ui:gpt:loading-slot', { position: slotData.position });
        $(slotDiv).html(`<div id="${elementId}" data-gpt-generated></div>`);

        let sizeMapping = this._createSizeMapping(slotData.viewportSizeMappings);
        let slot = googletag
            .defineSlot(adUnitPath, [], elementId)
            .defineSizeMapping(sizeMapping)
            .setCollapseEmptyDiv(slotData.collapseIfEmpty)
            .addService(googletag.pubads());

        _.each(slotData.customTargetingParameters, function (value, key) {
            slot.setTargeting(key, value);
            this._log('Custom targeting parameter', [key, value]);
        }.bind(this));

        googletag.display(elementId);
        createdSlots.push(slot);
        this._slots.push(slot);

        this._log('Slot created', slotData.position);
    };

    this._createOutOfPageSlot = function (adUnitPath, slotData, createdSlots) {
        this._log('Creating out of page slot', 'rm');
        this.trigger(document, 'ui:gpt:loading-slot', { position: 'rm' });

        let elementId = this.attr.gptDivIdPrefix + 'rm-' + almostRandom.get();
        $('#google-ad-banner-rm').append(`<div id="${elementId}" data-gpt-generated></div>`);

        let slot = googletag.defineOutOfPageSlot(adUnitPath, elementId).addService(googletag.pubads());

        _.each(slotData.customTargetingParameters, function (value, key) {
            slot.setTargeting(key, value);
            this._log('Custom targeting parameter', [key, value]);
        }.bind(this));

        googletag.display(elementId);
        createdSlots.push(slot);

        this._log('Out of page slot created', slotData.position);
    };

    this._createSizeMapping = function (viewportSizeMappings) {
        let sizeMappingBuilder = googletag.sizeMapping();

        _.each(viewportSizeMappings, function (sizeMappingEntry) {
            let viewportSize = [sizeMappingEntry.viewportSize.width, sizeMappingEntry.viewportSize.height];
            let slotSizes = _.reduce(sizeMappingEntry.slotSizes, function (memo, size) {
                memo.push([size.width, size.height]);
                return memo;
            }, []);

            sizeMappingBuilder.addSize(viewportSize, slotSizes);
        });

        return sizeMappingBuilder.build();
    };

    this._clearAllSlots = function () {
        this._log('Clearing all slots');

        $('[data-gpt-generated]').remove();
        $('[data-g-ad]').removeClass('hidden');
    };

    this._log = function (message, extraValues) {
        if (this.attr.initData.featureSwitches && this.attr.initData.featureSwitches['ad-logger'] && console && console.log) {
            if (extraValues) {
                console.log(message, extraValues);
            } else {
                console.log(message);
            }
        }
    };

    this._reloadAdsAfterResize = function (evt, payload) {
        if (!payload.userResize) {
            return;
        }

        if (this.attr.initData.gptData) {
            googletag.cmd.push(function () {
                googletag.pubads().refresh(this._slots);
                $('[data-g-ad]').removeClass('hidden');
            }.bind(this));
        }
    };

    this._reloadAdsAfterPaging = function (evt, payload) {
        if (!this.attr.initData.gptData) {
            return;
        }
        this._ensurePreviouslyLoadedListingAdsAreNotReloaded(payload);
        this._loadAds();
    };

    this._ensurePreviouslyLoadedListingAdsAreNotReloaded = function (payload) {

        if (payload.direction !== 'next') {
            $('#google-ad-banner-top-mobile').removeAttr('id');
        }
        else {
            // shows § before the ads are loaded. this avoids the slot from expanded post-loading
            $('#google-ad-banner-top-mobile').parent().show();
        }

        $('.only-mobile').each(function (index, item) {
            item = $(item);
            if (item.children().length > 0) {
                item.removeAttr('id');
            }
        });
    };


    this._escapeId = id => id.replace(/\//gi, '\\/');

    this._getOurAdDivFromDfpIframe = function (gptIframeId) {
        return $('#' + this._escapeId(gptIframeId)).closest('[data-gpt-generated]').attr('id');
    }

    this._thirdPartyCollapse = function (evt, gptIframeId) {
        try {
            // <div>                 <-- Our div for position
            //     <div>             <-- Our generated ad div
            //         <div>         <-- Google generated outer div
            //             <iframe>  <-- Google generated iframe for ad creative

            let ourAdDiv = this._getOurAdDivFromDfpIframe(gptIframeId);
            this._log('Third party collapse on ' + ourAdDiv);
            this._collapseDiv(this._escapeId(ourAdDiv));
        } catch (err) {
            this._log(err);
        }
    };

    this._thirdPartyResize = function (evt, gptIframeId, width, height) {
        try {
            let ourAdDiv = this._getOurAdDivFromDfpIframe(gptIframeId);
            this._log('Third party resize on' + ourAdDiv + ' ' + width + 'x' + height);
            this._adjustDivSize(ourAdDiv, width, height);
        } catch (err) {
            this._log(err);
        }
    };

    this._shouldSideSlotsBeLoaded = function () {
        let desktopWidthBreakpoint = 1250;
        if (!this.attr.initData.gptData.customTargetingParameters) {
            return;
        }
        let customTargetingParameters = this.attr.initData.gptData.customTargetingParameters;
        return customTargetingParameters.page === 'vip' &&
            customTargetingParameters.IsNewAdsForVip === 'true' &&
            $(window).width() >= desktopWidthBreakpoint &&
            customTargetingParameters.isAdsOnDesktop === 'True';
    };

    const offset = el => {
        let rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft,
            height: rect.bottom - rect.top
        }
    }


    this._configureStickyAds = () => {
        const adverts = [...document.querySelectorAll('[data-sticky-ad]')].filter(advert => advert.offsetParent !== null);
        
        if (!adverts || adverts.length < 1) {
            return;
        };

        const getBottomPosition = advert => advert.getAttribute('data-sticky-ad-bottom') ? $(advert.getAttribute('data-sticky-ad-bottom')) : null;

        const ads = adverts.map(advert => ({
            element: advert,
            position: offset(advert),
            bottomPosition: getBottomPosition(advert)
        }));

        const checkSingleAdPosition = advert => {
            const isSticky = advert.element.classList.contains('sticky');
            const isBottom = advert.element.classList.contains('bottom');
            const bottomPosition = advert.bottomPosition ? advert.bottomPosition.offset() : null;
            const atTop = !!(window.pageYOffset <= (advert.position.top - 70));
            const atBottom = bottomPosition ? !!(bottomPosition.top - (window.pageYOffset + 40) <= advert.position.height) : false;
            if (!atTop && !atBottom && !isSticky) {
                advert.element.classList.add('sticky');
                advert.element.classList.remove('bottom');
            } else if (atTop && isSticky) {
                advert.element.classList.remove('sticky');
                advert.element.classList.remove('bottom');
            } else if (atBottom && !isBottom) {
                advert.element.classList.remove('sticky');
                advert.element.classList.add('bottom');
            };
        };

        const checkAdPositions = () => ads.map(advert => checkSingleAdPosition(advert));
        const throttled = _.throttle(checkAdPositions, 25);

        $(window).on('scroll.google-ads', throttled);
        checkAdPositions();
    }

    /*
      Configures and enables sticky positioning for ad with pos=side2 only on vip page,
      holds logic for start and stop positioning.
    */
    this._configureStickyVipAds = function () {
        if (!this._shouldSideSlotsBeLoaded()) {
            return;
        }

        let vipAdContainer = $('#vip-ad-container');
        if (!vipAdContainer.length) {
            return;
        }

        // Used as parent to set absolute top position when reached bottom
        let anchorTop = vipAdContainer.offset().top;
        let view = $('#view');
        let stickyBottomTop = view.offset().top + view.height();
        let stickyMarginTop = 70;

        let stickyContainer;
        if (vipAdContainer.height() > $(window).height()) {
            stickyContainer = $('#google-ad-banner-side2-desktop');
        }
        else {
            stickyContainer = vipAdContainer;
        }

        let stickyTopStart = stickyContainer.offset().top;
        let stickyTopEnd = stickyBottomTop - stickyContainer.height();

        let scrollEventListener = function () {
            let scrollTop = $(window).scrollTop() + stickyMarginTop;
            let isAtStart = scrollTop <= stickyTopStart;
            let isAtEnd = scrollTop >= stickyTopEnd;

            if (isAtStart && !isAtEnd && stickyContainer.hasClass('sticky')) {
                // at top
                stickyContainer.removeClass('sticky').removeClass('bottom').css('top', '');
            } else if (!isAtStart && !isAtEnd && !stickyContainer.hasClass('sticky')) {
                // sticky
                stickyContainer.addClass('sticky').removeClass('bottom').css('top', stickyMarginTop);
            } else if (!isAtStart && isAtEnd && stickyContainer.hasClass('sticky')) {
                // at bottom
                stickyContainer.removeClass('sticky').addClass('bottom').css('top', stickyTopEnd - anchorTop);
            }
        };

        if (stickyBottomTop - stickyContainer.height() <= stickyTopStart) {
            // do not enable sticky
            vipAdContainer.addClass('no-sticky');
        }
        else {
            // enable sticky
            scrollEventListener();

            //throttling of the listener for better performance
            //var throttledListener = _.throttle(scrollEventListener, 50);
            $(window).on('scroll.google-ads', scrollEventListener);
        }
    };

    this._discoverNewSlotsAndInjectToGptData = function (gptData) {
        $('adslot').each(function () {
            let $this = $(this);

            // create new slot
            let position = $this.attr('data-g-ad-position');            
            let device = $this.attr('data-g-ad-device');            
            let slot = new AdSlot($this.attr('data-g-ad-format'), position, device);

            // fix the attributes in the dom element attributes
            $this.attr('id', slot.htmlDomId);
            $this.addClass(`g-ad-slot g-ad-slot-${position} only-${device}`);
            const gptSlot = slot.getGptSlotObject();
            gptData.slots.push(gptSlot);
        });
    }

    this._doTeardown = function () {
        console.log('teardown event listener in adverts');
        $(window).off('scroll.google-ads');
    }

    this.after('initialize', function () {
        if (typeof googletag === 'undefined') {
            return;
        }

        // mytradera is a reactjs app, we're using a 3rd part lib in the react world:
        // https://github.com/nfl/react-gpt
        if( 'subModule' in this.attr.initData && this.attr.initData.subModule === 'mytradera_spa'){
            return;
        }

        this._log('====== Google Publisher Tag Debug ======');

        this._initializeService();

        this._clearAllSlots();

        if (this.attr.initData.gptData) {

            this._configureStickyAds();
            this._configureStickyVipAds();

            this.on(document, 'utils:window-resize:resized', this._reloadAdsAfterResize);
            this.on(document, 'ui:search-result:after-pagination', this._reloadAdsAfterPaging);

            this.on(document, 'third-party:ads:collapse', this._thirdPartyCollapse);
            this.on(document, 'third-party:ads:resize', this._thirdPartyResize);

            this.on(document, 'data:navigation-filter:after-load', this._removeTopMobileSlotId);
            this.on(document, 'ui:teardown', this._doTeardown);

            this._discoverNewSlotsAndInjectToGptData(this.attr.initData.gptData);
            this._loadAds();
        }
    });
}

export default defineComponent.component(GoogleAdsLoader);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/ads/google-ads-loader.js